export default [
  {
    name: 'login',
    path: '/member/login',
    meta: {
      title: '로그인 화면',
      requiresAuth: false
    },
    component: () => import('@/components/member/login')
  },
  {
    path: '/member/findInfo',
    name: 'FindInfo',
    meta: {
      title: '아이디, 비번 찾기',
      requiresAuth: false
    },
    component: () => import('@/components/member/FindInfo')
  },
  {
    name: 'agreement',
    path: '/member/agreement',
    meta: {
      title: '회원 가입',
      requiresAuth: false
    },
    component: () => import('@/components/member/agreement')
  },
  {
    path: '/member/inviteAgreement',
    name: 'inviteAgreement',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/member/InvitedMemberAgreement')
  },
  {
    path: '/member/reset_password',
    name: 'resetPassword',
    meta: {
      title: '비밀번호 변경',
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "ResetPassword" */ '@/components/member/ResetPassword') // 이메일 -> 비밀번호 변경
  },
  {
    name: 'ChangePassword',
    path: '/member/change_password',
    meta: {
      title: '비밀번호 변경',
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "ChangePassword" */ '@/components/member/ChangePassword') // 비번변경 90일 경과 -> 비밀번호 변경
  },
  {
    name: 'OtpEmail',
    path: '/member/otp/email',
    meta: {
      title: '이메일 인증',
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "OtpEmail" */ '@/views/member/OtpEmail') // 이메일 인증
  },
  {
    name: 'OtpAuthy',
    path: '/member/otp/authy',
    meta: {
      title: 'otp 인증',
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "OtpAuthy" */ '@/views/member/OtpAuthy') // otp 인증
  },
  {
    path: '/todaySummary',
    name: 'Today 상담현황',
    component: () => import(/* webpackChunkName: "TodaySummaryLayout" */ '@/components/todaySummaryLayout')
  }
];



// WEBPACK FOOTER //
// ./src/router/subRoutes/member.js